/*
 * Copyright (c) 2019 brightlamp
 */

const Auth = () => import(/* webpackChunkName: "auth" */ '@/views/auth');
const Login = () => import(/* webpackChunkName: "auth" */ '@/views/auth/login');
const SignUp = () => import(/* webpackChunkName: "auth" */ '@/views/auth/sign-up');
const PasswordRecovery = () => import(/* webpackChunkName: "auth" */ '@/views/auth/password-recovery');

export default
[
    {
        path: '/',
        redirect:
        {
            name: 'Login'
        },
        component: Auth,
        meta:
        {
            requiresGuest: true
        },
        children:
        [
            {
                path: 'login',
                name: 'Login',
                component: Login,
                meta:
                {
                    title: 'Login'
                }
            },
            {
                path: 'signup',
                name: 'SignUp',
                component: SignUp,
                meta:
                {
                    title: 'Sign Up'
                }
            },
            {
                path: 'recovery',
                name: 'PasswordRecovery',
                component: PasswordRecovery,
                meta:
                {
                    title: 'PasswordRecovery'
                }
            }
        ]
    }
]